import * as React from 'react';
import { SVGProps } from 'react';

const SvgBell = (props: SVGProps<SVGSVGElement>): React.ReactElement => (
  <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" role="img" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.26.25c-2.767 0-5.084 2.128-5.084 4.84v4.092c0 .55-.485 1.068-1.176 1.068H1a.75.75 0 0 0 0 1.5h14a.75.75 0 0 0 0-1.5c-.361 0-.815-.146-1.172-.396-.37-.26-.485-.517-.485-.672V5.09c0-2.713-2.318-4.841-5.084-4.841Zm3.9 10a2.002 2.002 0 0 1-.317-1.068V5.09c0-1.805-1.564-3.341-3.584-3.341S4.676 3.286 4.676 5.09v4.092c0 .385-.086.746-.24 1.068h7.723Zm-6.16 2a.75.75 0 0 1 .75.75 1.25 1.25 0 1 0 2.5 0 .75.75 0 0 1 1.5 0 2.75 2.75 0 1 1-5.5 0 .75.75 0 0 1 .75-.75Z"
      fill="currentColor"
    />
  </svg>
);

export default SvgBell;
